import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/real-estate-signs',
    name: 'Real Estate Signs',
    component: () => import('../views/RealEstateSigns.vue'),
  },
  {
    path: '/custom-signage',
    name: 'Custom Signage',
    component: () => import('../views/CustomSignage.vue'),
  },
  {
    path: '/pylon-signage',
    name: 'Pylon Signage',
    component: () => import('../views/PylonSignage.vue'),
  },
  {
    path: '/factory-&-commercial-signage',
    name: 'Factory & Commercial Signage',
    component: () => import('../views/FactoryCommercialSignage.vue'),
  },
  {
    path: '/illuminated-signage',
    name: 'Illuminated Signage',
    component: () => import('../views/IlluminatedSignage.vue'),
  },
  {
    path: '/car-signage',
    name: 'Car Signage',
    component: () => import('../views/CarSignage.vue'),
  },
  {
    path: '/vinyl-frosting-&-wallpaper',
    name: 'Vinyl, Frosting & Wallpaper',
    component: () => import('../views/VinylFrostingWallpaper.vue'),
  },
  {
    path: '/office-&-shop-signage',
    name: 'Office & Shop Signage',
    component: () => import('../views/OfficeShopSignage.vue'),
  },
  {
    path: '/about-us',
    name: 'About Us',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/testimonials',
    name: 'Testimonials',
    component: () => import('../views/Testimonials.vue'),
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('../views/Blog.vue'),
  },
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: () => import('../views/ContactUs.vue'),
  },
  {
    path: '/blogs/:id',
    name: 'Blog',
    meta: {
      hide: true,
    },
    component: () => import('../views/BlogDetails.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: () => import('../views/Sitemap.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('../views/Unsubscribe.vue'),
  },
  {
    path: '/*',
    name: 'Not Found',
    meta: {
      hide: true,
    },
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
});

export default router;
